export { renderMenuGroup_unstable as renderMenuGroup } from '@fluentui/react-menu';
